import {
    KNOWN_DEVICES_FETCH_DATA,
    LOGIN_USER,
    REQUEST_COMPLETE,
    REQUEST_FAILED,
    REQUEST_PENDING,
    REQUEST_UNSENT,
    SUBMIT_DEVICE_DATA
} from "../../constant/reducerConstants";

// Add requests to track unsent status
const initialState = {
    [KNOWN_DEVICES_FETCH_DATA]: REQUEST_UNSENT,
    [SUBMIT_DEVICE_DATA]: REQUEST_UNSENT,
    [LOGIN_USER]: REQUEST_UNSENT
};

export function networkReducer(state = initialState, action) {
    switch (action.type) {
        case REQUEST_UNSENT:
            return {...state, [action.request]: REQUEST_UNSENT};
        case REQUEST_PENDING:
            return {...state, [action.request]: REQUEST_PENDING};
        case REQUEST_FAILED:
            return {...state, [action.request]: REQUEST_FAILED};
        case REQUEST_COMPLETE:
            return {...state, [action.request]: REQUEST_COMPLETE};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/reducer/networkReducer.js